import { RouteObject } from "react-router-dom";
import { Module } from "../../assets/types/common";
import RequireAuth from "../../auth/requireAuth";
import { LookupCategoryDto } from "../../services/dto/account/lookupCategoryDto";
import { LookupDto } from "../../services/dto/account/lookupDto";
import { LookupGroupDto } from "../../services/dto/account/lookupGroupDto";
import { LookupGroupContainer } from "../lookup/lookupgroup/lookupGroupContainer";
import { LookupTypeContainer } from "../lookup/lookuptype/lookupTypeContainer";
import { LookupValueContainer } from "../lookup/lookupvalue/lookupValueContainer";
import { ClaimContainer } from "./claim/claimContainer";
import { RoleContainer } from "./role/roleContainer";
import { SettingContainer } from "../setting/settingContainer";
import { SettingDto } from "../../services/dto/account/settingDto";
import { UserContainer } from "./user/userContainer";
import { permissions } from "../../assets/configuration/claimSettings";

export const AccountRoutes: RouteObject = {
  path: "account",
  children: [
    {
      path: "claim",
      element: (
        <RequireAuth requiredPermission={[permissions.SystemFull, permissions.ManageLookup]}>
          <ClaimContainer />
        </RequireAuth>
      ),
    },
    {
      path: "roles",
      element: (
        <RequireAuth requiredPermission={[permissions.SystemFull, permissions.ManageLookup]}>
          <RoleContainer />
        </RequireAuth>
      ),
    },
    {
      path: "lookuptype",
      element: (
        <RequireAuth requiredPermission={[permissions.SystemFull, permissions.ManageLookup]}>
          <LookupTypeContainer<LookupCategoryDto> moduleType={Module.Account} />
        </RequireAuth>
      ),
    },
    {
      path: "lookupgroup",
      element: (
        <RequireAuth requiredPermission={[permissions.SystemFull, permissions.ManageLookup]}>
          <LookupGroupContainer<LookupGroupDto> moduleType={Module.Account} />
        </RequireAuth>
      ),
    },
    {
      path: "lookupvalue",
      element: (
        <RequireAuth requiredPermission={[permissions.SystemFull, permissions.ManageLookup]}>
          <LookupValueContainer<LookupDto> moduleType={Module.Account} />
        </RequireAuth>
      ),
    },
    {
      path: "settings",
      element: (
        <RequireAuth requiredPermission={[permissions.SystemFull, permissions.ManageLookup]}>
          <SettingContainer<SettingDto> moduleType={Module.Account} />
        </RequireAuth>
      ),
    },
    {
      path: "user",
      element: (
        <RequireAuth requiredPermission={[permissions.SystemFull, permissions.ManageUser]}>
          <UserContainer />
        </RequireAuth>
      ),
    },
  ],
};
